export const ORDER_SUMMARY_CONSTANTS = {
  MEMBER_DISCOUNT: "Member's discount",
  RETAIL_LABEL: "Total value of product",
  TRADITIONAL_RETAIL_PRICE: "(Traditional retail price)",
  SUBTOTAL: "Subtotal",
  TOTAL: "Total",
  STICKY_CHECKOUT_TOTAL: "Your total including shipping",
  STANDARD_DELIVERY: "(want it faster?)",
  EXPRESS_DELIVERY: "(switch to standard Royal Mail)",
  MEMBERSHIP_FEE: "Membership fee",
  FREE_DELIVERY: "Free",
  ESTIMATED_DELIVERY: "Standard delivery",
  SUBTOTAL_TAX: "Sales Tax",
  DELIVERY_METHOD_TAX: "Shipping Tax",
  DISCOUNT_TOTAL: "Discounts"
};
